import store from '@/store/store.js'
import { TERMS_AND_CONDITIONS_ROUTE } from '@/router/routes/app.routes.js'
/**
 * @param {import('node_modules/vue-router/types/index').Route} _to
 * @param {import('node_modules/vue-router/types/index').Route} _from
 * @param {import('node_modules/vue-router/types/index').NavigationGuardNext} next
 */
function redirectToTermsAndConditions(to, _from, next) {
  if (store.getters.userShouldSeeTermsAndConditions && to.name !== TERMS_AND_CONDITIONS_ROUTE) {
    next(TERMS_AND_CONDITIONS_ROUTE)
  } else {
    next()
  }
}

export default redirectToTermsAndConditions
